<template>
  <div>
    <div class="add-jobs" v-if="!objectId">
      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="jobs-ul">
        <div
          @click="selectObject(list)"
          class="jobs-li" v-for="(list, index) in filteredList" :key="index"
        >
          <span>{{ list.name }}</span>
        </div>
      </div>
    </div>
    <div class="add-jobs" v-else v-loading="loading">
      <el-input placeholder="Поиск ..." v-model="jobSearch" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="jobs-ul">

        <el-table
          @selection-change="handleSelectionChange"
          empty-text="Работы не найдены"
          ref="multipleTable"
          :data="filteredJobs"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            property="name"
            label="Работы"
          >
          </el-table-column>
        </el-table>

        <div class="create-footer">
          <el-button @click="objectId = null">Назад</el-button>
          <el-button type="primary" @click="save" :disabled="!selected.length">Импортировать</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import _ from "lodash";
import {getChildList} from "../../../../utils/getChild";

export default {
  name: "ImportJobsContent",
  props: {
    plan: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      search: '',
      jobSearch: '',
      dialogObject: false,
      objectId: null,
      selected: [],
      loading: false,
      list: [],
      jobs: [],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredJobs() {
      return this.jobs.filter(object => {
        return object.name.toLowerCase().includes(this.jobSearch.toLowerCase());
      });
    },
  },

  async mounted() {
    this.fetchTree();
  },

  methods: {
    fire() {
      if (this.plan) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.plan.id)
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    fireSave() {
      if(this.$route.query.version) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if(this.$store.state.project.plan && this.$store.state.project.plan.id) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.plan.id)
      }
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    selectObject({id}) {
      this.objectId = id;
      this.fetchJobs();
    },
    fetchJobs() {
      this.fire()
        .collection('jobs')
        .where('type', '==', !this.$route.name || this.$route.name === 'objects' ? 'JOB' : this.$route.name)
        .where(`objects`, 'array-contains-any', [this.objectId]).get()
        .then((data) => {
          const result = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              _data: data,
            });
          });

          this.jobs = result;
        });
    },
    handleSelectionChange(selected) {
      this.selected = selected;
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = [
          {
            name: 'Из корневого коталога',
            id: 'all',
          },
          ..._.orderBy(getChildList(result), 'index', ['asc']),
        ];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;

      await this.fireSave()
        .collection('jobs')
        .orderBy("index", 'desc').limit(1)
        .get();

      let jobs_s = {
        index: 0
      };

      let batch = myFirestore.batch();
      this.selected.forEach((doc, key) => {
        const docRef = this.fireSave()
          .collection('jobs').doc();
        delete doc._data.id

        batch.set(docRef, {
          ...doc._data,
          index: jobs_s.index + key + 1,
          objects: [this.$route.params.id || 'all'],
        });
      });
      batch.commit().then((response) => {
        this.loading = false;
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Работы импортированы',
          type: 'success',
        });
        this.$emit('update');
        this.close();
      });
    },
    close() {
      this.dialogObject = false;
      this.clear();
      this.$emit('close')

    },
    clear() {
      this.objectId = null;
      this.selected = null;
      this.$emit('clear')
    },
  },
}
</script>

<style scoped lang="scss">
.import-jobs {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 500px) {
  .import-jobs {
    display: flex;
    flex-direction: column !important;
    height: 84px !important;
    justify-content: space-between !important;

    > > > button {
      width: 100%;
    }

    > > > .el-dialog__headerbtn {
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/ImportJobsContent.vue